import { canUseDOM } from './canUseDOM';

export const canUseViewport = !!(canUseDOM && window.screen);
